<template>
  <sf-banner-base
    v-bind="{ ...$props, ...$attrs }"
    level="system"
    @close="handleClose"
  >
    <template #default>
      <slot />
    </template>
    <template #actions>
      <slot name="actions" />
    </template>
    <template #link>
      <slot name="link" />
    </template>
  </sf-banner-base>
</template>
<script setup lang="ts">
import { bannerVariants, BannerVariant } from '@app/shared/types/banner'

import SfBannerBase from './sf-banner-base.vue'
import { BannerIconType } from './constants'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'SfBannerSystem',
})

interface Props {
  hasLongText?: boolean
  iconClass?: BannerIconType
  isFullWidth?: boolean
  selfManaged?: boolean
  showClose?: boolean
  title?: string
  variant: BannerVariant
}

withDefaults(defineProps<Props>(), {
  hasLongText: false,
  iconClass: '',
  isFullWidth: false,
  title: '',
  variant: bannerVariants.info,
})

const emit = defineEmits(['close'])

const handleClose = (): void => {
  emit('close')
}
</script>
